export default {"src":"/_next/static/media/x-logo-hover.0245a687.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};